module.exports = __webpack_public_path__ + "static/media/jira-utility-task-creation-automation.ae61e75e.md";